import { useIsMobile } from "@/hooks/use-mobile";
import { Monitor } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface DesktopOnlyGuardProps {
  children: React.ReactNode;
}

export function DesktopOnlyGuard({ children }: DesktopOnlyGuardProps) {
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  if (isMobile) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center p-6">
        <Card className="max-w-sm w-full">
          <CardContent className="pt-6 text-center space-y-4">
            <div className="mx-auto rounded-full bg-primary/10 p-4 w-fit">
              <Monitor className="h-8 w-8 text-primary" />
            </div>
            <h2 className="text-lg font-semibold">Desktop Feature</h2>
            <p className="text-sm text-muted-foreground">
              This feature is optimized for larger screens. Please open this page on a desktop or tablet to access it.
            </p>
            <Button variant="outline" className="w-full" onClick={() => navigate(-1)}>
              Go Back
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return <>{children}</>;
}
